import { faUser, faUserGroup } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import * as React from "react";
import { Trans, useTranslation } from "react-i18next";

import { useQueue } from "../../context/QueueContext";
import { Expert } from "../../models/expert";

interface Props {
  expert: Expert;
  defaultElement?: boolean;
  className?: string;
}

const ExpertQueueBadge: React.FC<Props> = ({ expert, defaultElement, className }) => {
  const { t } = useTranslation("expert");
  const { rawMemberQueues } = useQueue();

  const filteredExpertQueue = expert?.queue?.items?.filter((i) => i.type !== "BREAK" && !i.metadata.isEphemeral && !i.startedAt) || [];

  // member in queue and consultation started
  if (rawMemberQueues[expert.expertUid]?.items.length === 1 && rawMemberQueues[expert.expertUid].items[0].startedAt) {
    return (
      <div className={`bg-gray-100 text-center text-gray-800 text-sm font-medium
        items-center px-2.5 py-1 rounded-sm border-gray-500 ${className}`}
      >
        {t("queue.consultationStarted")}
      </div>
    );
  }

  // expert queue empty => ? empty element to preserve spacing
  if (!filteredExpertQueue.length) return defaultElement ? (<span className="text-sm font-medium py-1">{" "}</span>) : <></>;

  // member not in queue
  if (!rawMemberQueues[expert.expertUid] || rawMemberQueues[expert.expertUid].metadata.isEphemeral) {
    return (
      <div className={`bg-gray-100 text-center text-gray-800 text-sm font-medium
     items-center px-2.5 py-1 rounded-sm border-gray-500 ${className}`}
      >
        <Trans
          i18nKey="queue.waitingNb"
          ns="expert"
          count={filteredExpertQueue.length}
          values={{ queueLength: filteredExpertQueue.length }}
          components={[
            <FontAwesomeIcon className="mx-1" icon={filteredExpertQueue.length > 1 ? faUserGroup : faUser} />,
          ]}
        />
      </div>
    );
  }

  // member in queue
  return (
    <div className={`bg-gray-100 text-center text-gray-800 text-sm font-medium
   items-center px-2.5 py-1 rounded-sm border-gray-500 ${className}`}
    >
      <Link href="/my-queues">
        <Trans
          i18nKey={filteredExpertQueue.length > 1 ? "queue.waitingNbYou" : "queue.waitingYou"}
          ns="expert"
          values={{ queueLength: filteredExpertQueue.length - 1 }}
          components={[
            <FontAwesomeIcon className="mx-3-1" icon={filteredExpertQueue.length > 2 ? faUserGroup : faUser} />,
          ]}
        />
      </Link>
    </div>
  );
};

export default ExpertQueueBadge;
